import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/home/home";
import "bootstrap/dist/css/bootstrap.min.css";
import { store } from "./store";
import { Provider } from "react-redux";
import AppRoutes from "./routes.js";

import App from "./App";
import Form from "./components/form/form.js";
import Sign from "./components/sign/sign.js";
import Finish from "./components/finish/finish.js";

const isProd = window.location.hostname.includes("manager");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="">
    <Provider store={store}>
      <Routes>
        <Route path="/:token" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path={AppRoutes.start} element={<Form />} />
        <Route path={AppRoutes.sign} element={<Sign />} />
        <Route path={AppRoutes.finish} element={<Finish />} />
      </Routes>
    </Provider>
  </BrowserRouter>
);
